import React, { useCallback, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { FrequencyType } from 'components/NewsFeed/PollTaskForm/utils'
import { ViewToggle } from 'components/ui'
import { Box } from '@chakra-ui/core'
import SliderSwitch from 'components/CommonComponents/SliderSwitch'
import useLocaleText from 'components/useLocaleText'
import { useFormStepContext } from '../../FormStepContext'
import { getMaxAllowedDays } from './utils'
import { useInlineSettings } from '../../contexts/InlineSettingsContext'

export const RecurringSwitch = () => {
  const inlineSettings = useInlineSettings()
  const { control, setValue, watch, triggerValidation } = useFormContext()
  const { isEdit, setMaxAllowedOverdueDays } = useFormStepContext()

  const [savedDeadline, setSavedDeadline] = useState<string | null>(null)

  const currentDeadline = watch('deadline')

  const one_time_task = useLocaleText('one_time_task')
  const recuuring_task = useLocaleText('recuuring_task')

  const handleToggle = useCallback(
    async (isChecked: boolean) => {
      if (isChecked) {
        setSavedDeadline(currentDeadline)

        setValue('recurrence_frequency', FrequencyType.DAY)
        setValue('deadline', null)
        setValue('allowed_overdue_days', '')

        const maxDays = getMaxAllowedDays(FrequencyType.DAY)
        setMaxAllowedOverdueDays(maxDays)
      } else {
        if (savedDeadline) {
          setValue('deadline', savedDeadline)
        }
        setValue('recurrence_frequency', null)
        setValue('days_of_week', null)
        setValue('frequency_time', '')
        setMaxAllowedOverdueDays(61)
      }
      await triggerValidation('deadline')
    },
    [currentDeadline, savedDeadline, setMaxAllowedOverdueDays, setValue, triggerValidation]
  )

  if (inlineSettings) {
    return (
      <Controller
        name="is_recurring"
        control={control}
        valueName="value"
        onChange={([checked]) => checked}
        as={({ value, onChange }) => (
          <Box pointerEvents={isEdit ? 'none' : undefined} opacity={isEdit ? 0.5 : 1}>
            <ViewToggle
              options={[
                { id: 'once', label: 'one_time_task' },
                { id: 'recurring', label: 'recuuring_task' },
              ]}
              value={value ? 'recurring' : 'once'}
              onChange={(id) => {
                const checked = id === 'recurring'
                if (checked === !!value || isEdit) return
                onChange(checked)
                handleToggle(checked)
              }}
            />
          </Box>
        )}
      />
    )
  }

  return (
    <Controller
      name="is_recurring"
      control={control}
      key={'is_recurring'}
      valueName="isChecked"
      onChangeName="onChange"
      as={
        <SliderSwitch
          activeColor={inlineSettings ? '#222222' : undefined}
          activeLabel={recuuring_task}
          inactiveLabel={one_time_task}
          onChange={(isChecked) => handleToggle(isChecked)}
          isEdit={isEdit}
        />
      }
      onChange={(args: any[]) => {
        const isChecked = args[0]

        handleToggle(isChecked)
        return isChecked
      }}
    />
  )
}
